import { Formik } from 'formik'
import React, { useState } from 'react'
import Button from   '../../../../../utils/components/Button/Button'
import useModal from '../../../../../utils/hooks/useModal'
import styles from './Presentations.module.css'
const Presentations = ({ presentations, formik, create, edit, isEdit, setIsEdit }) => {
    const [presentation, setPresentation] = useState("")
    const [presentationId, setPresentationId] = useState(null)
    const [ref, isShowModal, setIsShowModal] = useModal(false)
    //const [isEdit, setIsEdit] = useState(null)
    return (
        <div>
            <div className={styles.input_container}>
                <input type="text" name="name" value={formik.values.name} onChange={formik.handleChange} xonChange={e => setPresentation(e.target.value)} />
                <Button text={`${isEdit ? 'editar' : 'crear'}`} onClick={formik.handleSubmit} xonClick={() => {
                    formik.resetForm()
                    /* if(!isEdit){
                        create(presentation,()=>{
                            setPresentation("")
                        })
                    }else{
                        edit(presentation,presentationId,()=>{
                            setPresentation("")
                            setPresentationId(null)
                            setIsEdit(false)
                        })
                    } */

                }} />
            </div>
            <div className={styles.grid_presentations}>
                {
                    presentations.map(presentation => (
                        <div key={presentation._id} className={styles.presentation_card}>
                            {presentation.name}
                            <div className={styles.presentation_card_btn}>
                                <Button styles={{ width: "50%" }} text='Editar' onClick={() => {
                                    setIsEdit(true)
                                    formik.setFieldValue('name', presentation.name)
                                    formik.setFieldValue('id', presentation._id)
                                    //setPresentation(presentation.name)
                                    //  setPresentationId(presentation._id)
                                }} />
                                <Button styles={{ width: "50%" }} onClick={() => setIsShowModal(true)} text='Eliminar' />
                            </div>
                        </div>
                    ))
                }
            </div>
            <Modal presentation={{}} displayModal={isShowModal} close={() => setIsShowModal(false)} />
        </div>
    )
}
const Modal = ({ presentation, displayModal, close }) => {
    const divStyle = {
        display: displayModal ? 'block' : 'none'
    }
    if (!presentation) {
        return <></>
    }
    return (
        <div className={"modal"} style={divStyle}>
            <div className="modal-content">
                <Button styles={{ width: "50%" }} onClick={() => {}} text='Eliminar' />
            </div>

        </div>
    )
}
export default Presentations